import { get, ref, getDatabase } from 'firebase/database'
import { LoaderFunction, MiddlewareFunction, redirect } from 'react-router-dom'
import { authContext } from '../../../middleware/auth'
import { tabNames } from '../../helpers'
import { db } from '../../../firebase/configs'
import { getCached, setCached } from '../../../middleware/cache'
import { logger } from '../../../helpers/logger'

export const redirectToDefaultLoader: LoaderFunction = async ({ context }) => {
    const user = context.get(authContext)

    if (!user?.uid) {
        throw redirect('/')
    }

    try {
        const centreUidSnapshot = await get(
            ref(getDatabase(), `users/${user.uid}/centreUid`)
        )
        const schoolId = centreUidSnapshot.val()

        if (typeof schoolId === 'string' && schoolId.length > 0) {
            throw redirect(`${tabNames.app.centre.index}/${schoolId}`)
        }
    } catch (error) {
        if (error instanceof Response) {
            throw error
        }
    }

    throw redirect(`/${tabNames.app.index}`)
}

export const centreMiddleware: MiddlewareFunction = async ({
    context,
    params,
}) => {
    const user = context.get(authContext)!
    const { centreId } = params

    if (!centreId) {
        // Navigate back to root to determine schoolId
        throw redirect(`${tabNames.app.centre.index}`)
    }

    // console.log(`Checking ${user.uid} in ${centreId}`)
    let membershipCheck = getCached<boolean>(`membership-${centreId}`)
    if (membershipCheck === null) {
        // console.log('Fetch schoolMembership')
        const membershipSnapshot = await get(
            ref(db, `users/${user.uid}/centres/${centreId}`)
        )
        membershipCheck = !membershipSnapshot.exists()
        setCached(`membership-${centreId}`, membershipCheck)
    }
    if (membershipCheck) {
        logger.warn(`User not part of school`)
        throw redirect('/dashboard')
    }
}
